import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-dropdown-list',
  templateUrl: 'dropdown-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownListComponent extends UIKitBaseComponent {
  // @ts-expect-error
  @Input() list: any[];
  // @ts-expect-error
  @Input() selectedItem: string | number;
  @Output() yearChange: EventEmitter<any> = new EventEmitter();

  selectItem(item: string | number) {
    this.selectedItem = item;
    this.yearChange.emit(item);
  }
}
